import React from 'react';

import {useStores} from '../../../stores/use-stores';

type ShopLoyaltyEnabledProps = {
  children: React.ReactNode;
};

/**
 * Show children when shop has loyalty enabled
 */
function ShopLoyaltyEnabled({children}: ShopLoyaltyEnabledProps) {
  const {shopSelectionStore} = useStores();
  return shopSelectionStore.loyaltyEnabled ? <>{children}</> : null;
}

export default ShopLoyaltyEnabled;
